import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Download = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m32.046 24.562-9.242 9.243c-.201.1-.402.301-.703.301-.302 0-.503-.1-.704-.301l-9.242-9.243a1.093 1.093 0 0 1 0-1.507 1.092 1.092 0 0 1 1.507 0l7.434 7.434V3.866c0-.603.502-1.105 1.005-1.105.502 0 1.004.502 1.004 1.105v26.624l7.434-7.434a1.092 1.092 0 0 1 1.507 0 1.093 1.093 0 0 1 0 1.507Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.005 27.375c.602 0 1.004.502 1.004 1.005v10.75h39.982V28.38c0-.603.502-1.005 1.004-1.005.603 0 1.005.502 1.005 1.005v11.855c0 .603-.502 1.005-1.005 1.005H1.005A1.007 1.007 0 0 1 0 40.235V28.38c0-.603.502-1.005 1.005-1.005Z"
  }));
});
Download.displayName = 'Download';
Download.defaultProps = {
  'aria-label': 'Download'
};
export default Download;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Download.js
// module id = 3771
// module chunks = 11